import {SET_FILTERS_LIST, SET_USER_TEXT_FILTER} from '../mutation-types';


const initialState = {
    filters: [],
    textFilter:  null
};
const getters = {
  getFilters: (state, getters) => {
    return state.filters;
  },
  getTextFilter: (state, getters) => {
    return state.textFilter;
  }
};

const mutations = {
    [SET_FILTERS_LIST](state, payload) {
        state.filters = payload;
    },
    [SET_USER_TEXT_FILTER](state, payload) {
      state.textFilter = payload;
    }
};

const actions = {
    getFilters({commit}) {
        return state.filters;
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}
